import cookie from 'js-cookie';

/**
 * sessionStorage
*/
export function setData(key, data) {
  sessionStorage.setItem(key, data);
}

export function getData(key) {
  return sessionStorage.getItem(key);
}

export function removeData(key) {
  sessionStorage.removeItem(key);
}

/**
 * cookie
*/
export function setCookie(key, data, options) {
  cookie.set(key, data, options);
}

export function removeCookie(key) {
  cookie.remove(key)
}

export function getCookie(key) {
  return cookie.get(key);
}

/**
 * localStorage
*/
export function setLocalData(key, data) {
    localStorage.setItem(key, data);
}

export function getLocalData(key) {
    return localStorage.getItem(key);
}

export function removeLocalData(key) {
    localStorage.removeItem(key);
}
